import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossedFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="m3.816.846.72.72C5.54 1.461 6.698 1.43 8 1.43c1.621 0 3.018.049 4.174.227.55.084 1.08.203 1.574.377C13.152.742 11.442.5 8 .5 6.124.5 4.763.572 3.816.846"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.462 3.452.505 1.495l.99-.99 14.005 14-.99.995-1.011-1.011c-1.042.825-2.7 1.011-5.499 1.011-5.77 0-6.69-.792-7.359-6.335-.403-3.342.014-4.957 1.821-5.713m5.682 5.682.19.19v1.21H3.667v-1.4zM6.71 7.7H3.334V6.3H5.31z"
                        fill="currentColor"
                    />
                    <path
                        d="M9.272 6.3 5.844 2.873A46 46 0 0 1 8 2.83c6.439 0 8.028.792 7.359 6.335-.132 1.095-.274 2.004-.461 2.759L10.673 7.7h1.994V6.3z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesStackedCrossedFilledSize16Glyph.displayName = 'CardLinesStackedCrossedFilledSize16Glyph';
